import { __read } from "tslib";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { BubbleContent } from "../bubble";
import { Popover } from "../popover";
export function SliderHandle(_a) {
    var _b;
    var classPrefix = _a.classPrefix, value = _a.value, vertical = _a.vertical, offset = _a.offset, dragging = _a.dragging, enableTip = _a.enableTip, tipFormatter = _a.tipFormatter;
    var _c = __read(useState(false), 2), hovering = _c[0], setHovering = _c[1];
    var scheduleRef = useRef(null);
    var offsetKey = vertical ? "bottom" : "left";
    useEffect(function () {
        if (scheduleRef.current) {
            scheduleRef.current();
        }
    }, [offset]);
    return (React.createElement(Popover, { visible: enableTip && (dragging || hovering), overlayStyle: {
            pointerEvents: "none",
        }, placement: vertical ? "left" : "top", transitionTimeout: 0, overlay: function (_a) {
            var placement = _a.placement, scheduleUpdate = _a.scheduleUpdate;
            scheduleRef.current = scheduleUpdate;
            var tips = tipFormatter(value);
            return (tips !== null && (React.createElement(BubbleContent, { placement: placement }, tips)));
        } },
        React.createElement("div", { className: classPrefix + "-slider__handle", style: (_b = {}, _b[offsetKey] = offset + "%", _b), onMouseEnter: function () { return setHovering(true); }, onMouseLeave: function () { return setHovering(false); } },
            React.createElement("span", { className: classNames(classPrefix + "-slider__handle-inner", {
                    "is-active": hovering || dragging,
                }) }))));
}
SliderHandle.displayName = "SliderHandle";
//# sourceMappingURL=SliderHandle.js.map